module.exports = __webpack_public_path__ + "img/figure-20.f48d70ce.png";